import { render, staticRenderFns } from "./PolicyAdd.vue?vue&type=template&id=08bce0f8&"
import script from "./PolicyAdd.vue?vue&type=script&lang=js&"
export * from "./PolicyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports